import {
  HTMLAttributes,
  ReactNode,
  useCallback,
  useEffect,
  useRef,
  useState,
} from "react";

import { NotificationTicketContainer } from "./styles";

interface INotificationTicketProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
}

export const NotificationTicket = ({
  children,
  ...props
}: INotificationTicketProps) => {
  const elRef = useRef<HTMLDivElement>(null);
  const [hasMultipleLines, setHasMultipleLines] = useState(false);

  const elementHasMultipleLines = useCallback(() => {
    const el = elRef.current;
    if (!el) return false;

    const styles = window?.getComputedStyle(el);
    const lineHeight = parseFloat(styles?.lineHeight);
    const elHeight = el?.offsetHeight;
    const linesCount = Math.round(elHeight / lineHeight);
    return linesCount > 1;
  }, []);

  useEffect(() => {
    if (elRef.current) setHasMultipleLines(elementHasMultipleLines());
  }, [elementHasMultipleLines]);

  return (
    <NotificationTicketContainer
      {...props}
      ref={elRef}
      data-element-has-multiple-lines={hasMultipleLines}
    >
      {children}
    </NotificationTicketContainer>
  );
};
